import { useEffect, useState } from 'react';
import { AutoComplete, Input } from 'antd';
import { getRelationkeyLabel } from 'Services/WeaverUtils'

const SelectOrCreateRelation = ({ query, placeholder, disabled, ...rest }) => {

  const [relationsData, setRelationsData] = useState([])

  query ??= new Weaver.Sparql(`
    SELECT DISTINCT ?rels WHERE {
      ?from ?rels ?to
      FILTER(isURI(?to))
    }
  `)

  useEffect(() => {
    (async () => {
      const { rels } = await query.find()
      const parsedRels = rels.map((n) => {
        return {
          value: n.id(),
          label: getRelationkeyLabel(n.id())
        }
      })
      setRelationsData(_.uniqBy(parsedRels, 'label'))
    })()
  }, [])

  const filterOption = (inputValue, option) => option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1

  return disabled ? (
    <Input
      disabled={disabled}
      { ...rest }
    />
  ) : (
    <AutoComplete
      options={relationsData}
      filterOption={filterOption}
      style={{ width: '100%' }}
      {...rest}
    >
      <Input placeholder={placeholder} />
    </AutoComplete>
  )
};

export default SelectOrCreateRelation;
